import {
  deletePhoto as deletePhotoService,
  deletePhotos as deletePhotosService,
  presigneUrl as presigneUrlService,
} from "../../services/photo-management/photo-management.service";
import { handlerErrorV2 } from "../../utils/errors";

import {
  uploadFile as uploadPhotoService,
} from "../../services/upload/upload.service";

const usePhotoManagement = () => {
  const deletePhoto = async (filename) => {
    try {
      const result = await deletePhotoService({ name: filename });
      if (result.error) {
        return { error: result?.error?.message || "Something went wrong. Please try again." };
      }
    
      return { error: null, data: result.data };
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: message };
    }
  };

  const deletePhotos = async (data = []) => {
    try {
      const files = data.map((file) => ({ name: file }));
      const result = await deletePhotosService(files);
      if (result.error) {
        return { error: result?.error?.message || "Something went wrong. Please try again." };
      }
    
      return { error: null, data: result.data };
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: message };
    }
  };

  const uploadPhoto = async (files = []) => {
    try {
      const resultUpload = await presigneUrlService(files);
      if (resultUpload.error || !resultUpload.data) {
        return { error: resultUpload.error.message };
      } else {
        const result = await Promise.all(
          resultUpload.data.map(async (file) => {
            const { data, error } = file;
            if (!data) {
              return {
                name: error.file,
                error: error?.msg || "Something went wrong. Please try again.",
              };
            }
            const currentPhoto = files.find((item) => item.id === data?.file?.id);
            if (currentPhoto) {
              await uploadPhotoService(data.presignedUrl, currentPhoto.file);
              return {
                id: data.file.id,
                name: data.filename,
                link: `photos/${data.filename}`,
              };
            }

            return {
              id: data.file.id,
              error: 'Photo not found'
            };
            
          })
        );

        if (!result) {
          return { error: "Something went wrong. Please try again." };
        } else {
          return { error: null, data: result };
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: message };
    }
  };

  return {
    deletePhoto,
    deletePhotos,
    uploadPhoto
  };
};

export default usePhotoManagement;
